import * as React from 'react';
import {Card, CardContent, Typography, Box} from '@mui/material';
import {useTranslate} from 'react-admin';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {useTheme} from '@mui/material/styles';

export const ConsiderShippingReturnMessage = () => {
    const translate = useTranslate();
    const theme = useTheme();

    return (
        <Box mt={{xs: '20px', md: '0'}} width={{xs: '100%'}}>
            <Card
                sx={{
                    backgroundColor: theme.palette.info.light,
                    color: theme.palette.info.contrastText,
                    marginTop: 2,
                }}
            >
                <CardContent>
                    <Box display="flex" alignItems="center" mb={1}>
                        <ErrorOutlineIcon sx={{marginRight: 1}}/>
                        <Typography variant="h6" component="div">
                            {translate('resources.order.return.considerShippingRefundTitle')}
                        </Typography>
                    </Box>
                    <Typography variant="body2" component="div">
                        {translate('resources.order.return.considerShippingRefundMessage')}
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};
